import { render, staticRenderFns } from "./GroupSetting.vue?vue&type=template&id=3747d300&"
import script from "./GroupSetting.vue?vue&type=script&lang=js&"
export * from "./GroupSetting.vue?vue&type=script&lang=js&"
import style0 from "./GroupSetting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "GroupSetting.vue"
export default component.exports